import Vue from "vue";


import Page_ec5a98ab5031319b594e7ee1ff4a71a6 from "@/views/100_Welcome.vue";

import Page_f4673e038b5c23a9cedf27486b17706a from "@/views/200_Introduction.vue";

import Page_34d64777917a87a52d01aca16fcf0325 from "@/views/300_What_Is_Security_Awareness.vue";

import Page_8cd1c73b87ffa80e6c29e8aaac53ba70 from "@/views/400_Take_Your_Guess.vue";

import Page_632484136418857f3592818706af904d from "@/views/500_What’s_the_Worst_That_Can_Happen.vue";

import Page_53254885ae605a3b1f3047772d14e31f from "@/views/600_The_Anatomy_of_a_Phishing_Email.vue";

import Page_0443ef609eb70e7b8c0f1936576c0cc5 from "@/views/700_How_To_Avoid_Phishing_Scams.vue";

import Page_efe44365e6621915b6d2be39ea489fc3 from "@/views/800_Phishing_Email_Exercise.vue";

import Page_399bd703dfdf7776cdd8556da71fb9c2 from "@/views/900_Phishing_Beyond_Emails.vue";

import Page_28133dac997c5e3fd1bf5c94783e3940 from "@/views/1000_Password_Security.vue";

import Page_34d7ad048eb33b048198a00521867898 from "@/views/1100_Mobile_Device_Security.vue";

import Page_09b033aef4aabe52962c119db0093ebe from "@/views/1200_Social_Media.vue";

import Page_c59c41f9215472ca67bfe98cd05a3021 from "@/views/1300_The_Dangers_of_Disinformation.vue";

import Page_710cbe732938c664270331dac224b21c from "@/views/1400_Simple_Ways_To_Protect_Your_Data.vue";

import Page_9b1e33c30a1939ac6bed36f5d206ccc7 from "@/views/1500_Wrap_Up_and_Key_Takeaways.vue";

import Page_fa71e04210ab1e6da0b0e9fadcb9db64 from "@/views/1600_Quiz.vue";

import Page_2075f54eff1178b4069c4800d42b5f9f from "@/views/1700_Congratulations.vue";



import QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636 from "@/views/quiz/question-01.vue";

import QuizQuestion_cc4c2363c0bc7d5db9eb58c0679e354a from "@/views/quiz/question-02.vue";

import QuizQuestion_373ed3ae165d65507cced09937bc6e1d from "@/views/quiz/question-03.vue";

import QuizQuestion_f9bcc461b94530f30ff5ee0eb534d8ec from "@/views/quiz/question-04.vue";

import QuizQuestion_f82c187ebab1f0c02eb4d6e197090912 from "@/views/quiz/question-05.vue";

import QuizQuestion_854c0a05df63beb20aede5f975303fe6 from "@/views/quiz/question-06.vue";

import QuizQuestion_b9c892d3fd60f057c26c0702fbc1ac94 from "@/views/quiz/question-07.vue";

import QuizQuestion_6aa02a2a58132339ffee1ba112594ccd from "@/views/quiz/question-08.vue";




import BTB_INTRO from '@/views/BTB_INTRO.vue';
import BTB_OUTRO from '@/views/BTB_OUTRO.vue';
import BTB_INSERT_TEMPLATE from '@/views/BTB_INSERT_TEMPLATE.vue';


Vue.component("Page_ec5a98ab5031319b594e7ee1ff4a71a6", Page_ec5a98ab5031319b594e7ee1ff4a71a6);

Vue.component("Page_f4673e038b5c23a9cedf27486b17706a", Page_f4673e038b5c23a9cedf27486b17706a);

Vue.component("Page_34d64777917a87a52d01aca16fcf0325", Page_34d64777917a87a52d01aca16fcf0325);

Vue.component("Page_8cd1c73b87ffa80e6c29e8aaac53ba70", Page_8cd1c73b87ffa80e6c29e8aaac53ba70);

Vue.component("Page_632484136418857f3592818706af904d", Page_632484136418857f3592818706af904d);

Vue.component("Page_53254885ae605a3b1f3047772d14e31f", Page_53254885ae605a3b1f3047772d14e31f);

Vue.component("Page_0443ef609eb70e7b8c0f1936576c0cc5", Page_0443ef609eb70e7b8c0f1936576c0cc5);

Vue.component("Page_efe44365e6621915b6d2be39ea489fc3", Page_efe44365e6621915b6d2be39ea489fc3);

Vue.component("Page_399bd703dfdf7776cdd8556da71fb9c2", Page_399bd703dfdf7776cdd8556da71fb9c2);

Vue.component("Page_28133dac997c5e3fd1bf5c94783e3940", Page_28133dac997c5e3fd1bf5c94783e3940);

Vue.component("Page_34d7ad048eb33b048198a00521867898", Page_34d7ad048eb33b048198a00521867898);

Vue.component("Page_09b033aef4aabe52962c119db0093ebe", Page_09b033aef4aabe52962c119db0093ebe);

Vue.component("Page_c59c41f9215472ca67bfe98cd05a3021", Page_c59c41f9215472ca67bfe98cd05a3021);

Vue.component("Page_710cbe732938c664270331dac224b21c", Page_710cbe732938c664270331dac224b21c);

Vue.component("Page_9b1e33c30a1939ac6bed36f5d206ccc7", Page_9b1e33c30a1939ac6bed36f5d206ccc7);

Vue.component("Page_fa71e04210ab1e6da0b0e9fadcb9db64", Page_fa71e04210ab1e6da0b0e9fadcb9db64);

Vue.component("Page_2075f54eff1178b4069c4800d42b5f9f", Page_2075f54eff1178b4069c4800d42b5f9f);



Vue.component("QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636", QuizQuestion_c3e3b6805a8c7689d7b6d195311fd636);

Vue.component("QuizQuestion_cc4c2363c0bc7d5db9eb58c0679e354a", QuizQuestion_cc4c2363c0bc7d5db9eb58c0679e354a);

Vue.component("QuizQuestion_373ed3ae165d65507cced09937bc6e1d", QuizQuestion_373ed3ae165d65507cced09937bc6e1d);

Vue.component("QuizQuestion_f9bcc461b94530f30ff5ee0eb534d8ec", QuizQuestion_f9bcc461b94530f30ff5ee0eb534d8ec);

Vue.component("QuizQuestion_f82c187ebab1f0c02eb4d6e197090912", QuizQuestion_f82c187ebab1f0c02eb4d6e197090912);

Vue.component("QuizQuestion_854c0a05df63beb20aede5f975303fe6", QuizQuestion_854c0a05df63beb20aede5f975303fe6);

Vue.component("QuizQuestion_b9c892d3fd60f057c26c0702fbc1ac94", QuizQuestion_b9c892d3fd60f057c26c0702fbc1ac94);

Vue.component("QuizQuestion_6aa02a2a58132339ffee1ba112594ccd", QuizQuestion_6aa02a2a58132339ffee1ba112594ccd);




Vue.component('BTB_INTRO', BTB_INTRO);
Vue.component('BTB_OUTRO', BTB_OUTRO);
Vue.component('BTB_INSERT_TEMPLATE', BTB_INSERT_TEMPLATE);
